export const defaultError: string = "Something went wrong!";

export const defaultSuccess: string = "Success!";
